document.addEventListener("DOMContentLoaded", function () {
    // Get all the select elements with class 'variant-picker__select'
    var selectElements = document.querySelectorAll('.variant-picker__select');

    // Loop through each select element
    selectElements.forEach(function (selectElement) {
        // Get all the option elements within this select element
        var optionElements = selectElement.querySelectorAll('option');

        // Loop through each option element
        optionElements.forEach(function (optionElement) {
            // Hide the option element
            optionElement.style.display = 'none';
        });

        // Create a default option element
        var defaultOption = document.createElement('option');
        defaultOption.text = 'Select an option';
        defaultOption.value = '';
        defaultOption.selected = true;
        defaultOption.disabled = true;

        // Add the default option to the select element
        selectElement.appendChild(defaultOption);
    });
});
